export default __webpack_public_path__ + "static/media/57-min.ddd9fb31.png";